import { AdUnitProvidersConfig } from '@/modules/adv'
import { AdProviderNames } from '@/types'

const NO_INIT_SCREEN_CLIDS = ['p_a68073c6-abde-4a55-a494-5ddb9ec8baa0']

type Config = {
    isInitGameScreenHidden?: boolean
    inGameAdUnitProviderConfig?: Partial<AdUnitProvidersConfig<AdProviderNames>> | undefined
    inGameProviderKeys?: AdProviderNames[] | undefined
}

export function getConfigByClid(clid: string): Config {
    if (NO_INIT_SCREEN_CLIDS.includes(clid)) {
        return {
            isInitGameScreenHidden: true,
            inGameAdUnitProviderConfig: {
                [AdProviderNames.GOOGLE_INSTREAM_CHEAP]: {
                    desktop: {
                        interstitial_preroll: 'instream_preroll_no_floor_desktop',
                        interstitial: 'instream_no_floor_desktop',
                        rewarded: 'instream_rewarded_no_floor_desktop',
                    },
                    mobile: {
                        interstitial_preroll: 'instream_preroll_no_floor_mobile',
                        interstitial: 'instream_no_floor_mobile',
                        rewarded: 'instream_rewarded_no_floor_mobile',
                    },
                },
            },
            inGameProviderKeys: [AdProviderNames.GOOGLE_INSTREAM, AdProviderNames.GOOGLE_INSTREAM_CHEAP],
        }
    }

    return {}
}
